export const styles: any = {
  paddingY: {
    base: 4,
    md: 8,
  },
};
